export interface OrderedItem {
    id: OrderedItemId;
    name: string;
}

export type OrderedItemId = string | number;

export interface OrderedItemActiveMenu {
    [OrderedItemMenuType.ReplaceItemMenu]: number | undefined;
    [OrderedItemMenuType.AddItemMenu]: boolean;
}

export interface OrderedItemErrorState {
    message: string;
    icon: string;
    type: OrderedItemErrorType;
}

export enum OrderedItemMenuType {
    ReplaceItemMenu = "REPLACE_ITEM_MENU",
    AddItemMenu = "ADD_ITEM_MENU"
}

export enum OrderedItemErrorType {
    Error = "error",
    Warning = "warning",
    Info = "info"
}
